export const PROJECTS_PER_PAGE = 30;
